import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { HomePageLayoutBlueprint } from '@backstage/plugin-home-react/alpha';

const EkimetricsHomeLayoutExtension = HomePageLayoutBlueprint.make({
  name: 'ekimetrics',
  params: {
    loader: async () =>
      (await import('./EkimetricsHomeLayout')).EkimetricsHomeLayout,
  },
});

export const homeModule = createFrontendModule({
  pluginId: 'home',
  extensions: [EkimetricsHomeLayoutExtension],
});
